import React, {Component} from 'react';
import {Button, Card, CardBody, CardGroup, Col, Container, Input, InputGroup, Row} from 'reactstrap';
import {postData} from '../../../api/doLogin.js';

class Login extends Component {
  constructor(props){
    super(props);
    this.state = {
      username:"",
      password:"",
      errorMsg:this.props.errorMsg || "",
      isProcessing:false,
    }
    this.usernameRef = React.createRef();
    this.passwordRef = React.createRef();
  }
  login(){
    var self = this;
    self.setState({errorMsg:"",isProcessing:true});
    //alert(this.state.username + " " + this.state.password);
    postData('login',{username:this.state.username,password:this.state.password})
    .then((data) => {
      // console.log(JSON.stringify(data))
      if (data.status === "success"){
        //set cookie and navigate to home page through App Component
        this.props.mainCtrl.loginSuccess(data.data.id,data.data.token,data.data.expiresAt,data.data.perms, data.data.lmsMenu);
      } else {
        self.setState({errorMsg:data.message,isProcessing:false});
      }
    }) // JSON-string from `response.json()` call
    .catch(error => {
      console.error(error)
      self.setState({errorMsg:error,isProcessing:false});
    });
     //onClick={()=>this.props.mainCtrl.setState({token:"test",loginID:1})}
  }
  _handleKeyPress(e,type){
    if (e.key === 'Enter') {
      if (type=="username"){
        this.passwordRef.focus()
      } else if (type=="password"){
        this.login();
      }
    }
  }
  render() {
    return (
      <div className="app flex-row align-items-center">
        <Container>
          <Row className="justify-content-center">
          {!this.state.isProcessing ?
            <Col md="8">
              <CardGroup>
                <Card className="p-4">
                  <CardBody>
                    <h1>Login</h1>
                    <p className="text-muted">Sign in to your AFBN agent account</p>
                    <InputGroup className="mb-3">
                      <div className="input-group-prepend">
                        <span className="input-group-text">
                          <i className="icon-user"></i>
                        </span>
                      </div>
                      <Input type="text" placeholder="Username" innerRef={input => (this.usernameRef = input)} onKeyPress={(e)=>this._handleKeyPress(e,'username')} onChange={(evt)=>this.setState({username:evt.target.value})}/>
                    </InputGroup>
                    <InputGroup className="mb-4">
                      <div className="input-group-prepend">
                        <span className="input-group-text">
                          <i className="icon-lock"></i>
                        </span>
                      </div>
                      <Input type="password" placeholder="Password" innerRef={input => (this.passwordRef = input)} onKeyPress={(e)=>this._handleKeyPress(e,'password')} onChange={(evt)=>this.setState({password:evt.target.value})}/>
                    </InputGroup>
                    {this.state.errorMsg.length > 0 && (
                    <Row>
                      <Col xs="12">
                        <div style={{color:"#FF0000"}}>{this.state.errorMsg}</div>
                      </Col>
                    </Row>
                    )}
                    <Row>
                      <Col xs="6">
                        <Button color="primary" className="px-4" onClick={()=>this.login()}>Login</Button>
                      </Col>
                      <Col xs="6" className="text-right">
                        {/*<Button color="link" className="px-0" onClick={()=>this.props.history.push('/forgot')} style={{paddingBottom:0}}>Forgot password?</Button>*/}
                        <Button color="link" className="px-0 d-lg-none" active onClick={()=>this.props.history.push('/register')} style={{paddingTop:0}}>Register Now!</Button>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </CardGroup>
            </Col>
            :
            <Col md="6">
              <div className="clearfix">
                <h4 className="pt-4" style={{textAlign:'center'}}>Please wait while we try to log you in...</h4>
              </div>
            <Card>
              <CardBody>
                <div className="sk-wave">
                  <div className="sk-rect sk-rect1"></div>&nbsp;
                  <div className="sk-rect sk-rect2"></div>&nbsp;
                  <div className="sk-rect sk-rect3"></div>&nbsp;
                  <div className="sk-rect sk-rect4"></div>&nbsp;
                  <div className="sk-rect sk-rect5"></div>
                </div>
              </CardBody>
            </Card>
            </Col>
          }
          </Row>
        </Container>
      </div>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/views/Pages/Login/Login.js